import api from "@/api/api";
import { getRoles } from "@/api/users/users-services";
import { getQuestionByAlias } from "@/api/forms-questions/forms-questions-services";

export const PROBLEM_TYPE_ALIAS = "problem_type";

export const fetchProblemTypeQuestion = async () => {
  const question = await getQuestionByAlias(PROBLEM_TYPE_ALIAS);
  return question || null;
};

export const fetchProblemTypeOptions = async () => {
  const question = await fetchProblemTypeQuestion();
  if (!question || !Array.isArray(question.options)) {
    return [];
  }
  return question.options;
};

export const fetchRolesWithProblemTypeVisibility = async () => {
  const roles = await getRoles();
  if (!Array.isArray(roles)) {
    return [];
  }

  return roles.map((role) => {
    const visibility = Array.isArray(role.problemTypeVisibility)
      ? role.problemTypeVisibility
      : null;

    const hasRestrictions = Array.isArray(visibility) && visibility.length > 0;

    return {
      id: role.id,
      name: role.name,
      permissions: role.permissions,
      rawProblemTypeVisibility: role.problemTypeVisibility ?? null,
      mode: hasRestrictions ? "restricted" : "all",
      selectedProblemTypes: hasRestrictions ? visibility : [],
    };
  });
};

export const updateRoleProblemTypeVisibility = async (
  roleId,
  selectedProblemTypes,
) => {
  if (!roleId) {
    throw new Error("Role id is required to update problemTypeVisibility.");
  }

  let problemTypeVisibility = null;

  if (Array.isArray(selectedProblemTypes) && selectedProblemTypes.length > 0) {
    problemTypeVisibility = selectedProblemTypes;
  }

  const response = await api.put(`/roles/${roleId}`, {
    problemTypeVisibility,
  });

  return response.data;
};
